<script setup lang="ts">
import type { Component } from 'vue'
import Modal from './Modal.vue'
import ButtonDaisy from '@/components/common/buttons/ButtonDaisy.vue'
import { CheckIcon } from '@heroicons/vue/24/solid'

interface Props {
  showModal: boolean
  title: string
  body?: string
  confirmText?: string
  cancelText?: string
  confirmVariant?: 'primary' | 'secondary' | 'accent' | 'warning' | 'error' | 'success'
  confirmDisabled?: boolean
  confirmIcon?: Component
  loading?: boolean
  maxWidth?: string
}

withDefaults(defineProps<Props>(), {
  confirmText: 'Confirmer',
  cancelText: 'Annuler',
  confirmVariant: 'primary',
  confirmDisabled: false,
  loading: false,
  maxWidth: 'md',
})

const emit = defineEmits<{
  confirm: []
  cancel: []
}>()
</script>

<template>
  <Modal :show-modal="showModal" :title="title" :max-width="maxWidth" @close="emit('cancel')">
    <template #content>
      <div class="space-y-4 mt-4">
        <template v-if="$slots.body">
          <slot name="body" />
        </template>
        <p v-else-if="body" class="text-base-content/80">{{ body }}</p>
        <div class="flex justify-end gap-2 mt-6">
          <ButtonDaisy :text="cancelText" variant="ghost" @click="emit('cancel')" />
          <ButtonDaisy
            :text="confirmText"
            :variant="confirmVariant"
            :loader="loading"
            :disabled="confirmDisabled"
            :icon="confirmIcon ?? CheckIcon"
            @click="emit('confirm')"
          />
        </div>
      </div>
    </template>
  </Modal>
</template>
